// src/locales/en/brands.js - Updated version
export const brands = {
  // Page titles and descriptions
  title: "Product Brands",
  description: "Manage product brands for better organization and customer recognition",
  
  // Navigation
  addBrand: "Add Brand",
  createNewBrand: "Create New Brand",
  editBrand: "Edit Brand",
  createFirstBrand: "Create First Brand",
  
  // Form Fields
  brandName: "Brand Name",
  brandNamePlaceholder: "Enter brand name (e.g., Nike, Samsung, Apple)",
  brandDescription: "Brand Description",
  brandDescriptionPlaceholder: "Enter a brief description of the brand",
  brandLogo: "Brand Logo",
  uploadLogo: "Upload Logo",
  chooseLogo: "Choose Logo",
  removeLogo: "Remove Logo",
  logoHint: "Accepted formats: JPG, PNG, WEBP. Maximum size: 2MB",
  
  // Table Headers and Content
  filteredResults: "{{count}} of {{total}} brands",
  totalBrands: "{{count}} brands",
  searchBrands: "Search brands by name or description...",
  
  // Selector specific
  selectBrand: "Select brand",
  searchBrandsPlaceholder: "Search brands...",
  noBrandsFound: "No brands found matching your search",
  noBrandsAvailable: "No brands available",
  createBrand: "Create Brand",
  
  // Validation Messages
  nameRequired: "Brand name is required",
  nameMinLength: "Brand name must be at least 2 characters",
  nameMaxLength: "Brand name cannot exceed 100 characters",
  duplicateNameError: "Brand with this name already exists",
  invalidLogoType: "Please upload a valid image file (JPG, PNG, WEBP)",
  logoTooLarge: "Logo file size must be less than 2MB",
  
  // Actions
  createBrand: "Create Brand",
  updateBrand: "Update Brand",
  savingBrand: "Saving...",
  
  // Success/Error Messages
  brandCreatedSuccess: "Brand '{{brandName}}' created successfully!",
  brandUpdatedSuccess: "Brand '{{brandName}}' updated successfully!",
  brandDeletedSuccess: "Brand '{{brandName}}' has been deleted successfully.",
  failedToCreate: "Failed to create brand. Please try again.",
  failedToUpdate: "Failed to update brand. Please try again.",
  failedToDelete: "Failed to delete brand. Please try again.",
  failedToLoadBrand: "Failed to load brand details. Please try again.",
  
  // Loading states
  loadingBrands: "Loading Brands...",
  loadingBrandsDesc: "Please wait while we fetch your product brands.",
  
  // Empty states
  noBrands: "No brands yet",
  noBrandsDesc: "Create your first product brand to start organizing your products by manufacturer or brand.",
  noSearchResults: "No brands found",
  noSearchResultsDesc: "Try adjusting your search terms or clear filters to see all brands.",
  
  // Confirmation dialogs
  confirmDelete: "Are you sure you want to delete the brand '{{brandName}}'? This action cannot be undone and may affect products using this brand."
};